import i18n from 'i18next';
import React from 'react';
import { SvgImage, SvgType } from '../../../../base/svg/svg';

export enum ModalVariant {
  Success = 'Success',
  Error = 'Error',
  ConfirmationRequest = 'ConfirmationRequest',
  WarningTextPicker = 'WarningTextPicker',
  PlainTextPicker = 'PlainTextPicker'
}

export const ModalIcon = {
  [ModalVariant.Success]: <SvgImage type={SvgType.Check}/>,
  [ModalVariant.Error]: <SvgImage type={SvgType.Error}/>,
  [ModalVariant.ConfirmationRequest]: <SvgImage type={SvgType.Alert}/>,
  [ModalVariant.WarningTextPicker]: <SvgImage type={SvgType.Alert}/>,
  [ModalVariant.PlainTextPicker]: null,
};

export const ModalTitle = {
  [ModalVariant.Success]: i18n.t('common.congratulations'),
  [ModalVariant.Error]: i18n.t('common.error'),
  [ModalVariant.ConfirmationRequest]: i18n.t('common.attention'),
  [ModalVariant.WarningTextPicker]: i18n.t('common.attention'),
  [ModalVariant.PlainTextPicker]: i18n.t('common.textModalTitle'),
};
